import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import type { Ticket } from "../../../types/models/ticket.model.type";
import type { CheckTicketsState } from "../../../types/states/ticket.state.type";
import { MyPendingTicketsFilterRequest } from "../../../types/request/ticket.request.type";

const initialState: CheckTicketsState = {
  isFetching: false,
  data: [],
  error: undefined,
  selectedItem: undefined,
  request: undefined,
};

const checkTicketsSlice = createSlice({
  name: "checkTickets",
  initialState,
  reducers: {
    rxStartFetching: (state) => {
      state.isFetching = true;
    },
    rxSuccessFetchingData: (state, { payload }: PayloadAction<Ticket[]>) => {
      state.isFetching = false;
      state.data = payload;
      state.error = undefined;
      if (state.selectedItem) {
        const foundSelected = payload.find((e) => e.idTicket === state.selectedItem!.idTicket);
        if (!foundSelected) {
          state.selectedItem = undefined;
        } else {
          state.selectedItem = foundSelected;
        }
      }
    },
    rxErrorFetchingData: (state, { payload }: PayloadAction<string>) => {
      state.isFetching = false;
      state.data = [];
      state.error = payload;
    },
    rxSetRequest: (state, { payload }: PayloadAction<MyPendingTicketsFilterRequest>) => {
      state.request = payload;
    },
    rxSetSelectedTicket: (state, { payload }: PayloadAction<Ticket>) => {
      if (state.selectedItem) {
        state.selectedItem = state.selectedItem.idTicket === payload.idTicket ? undefined : payload;
      } else {
        state.selectedItem = payload;
      }
    },
  },
});

export const { rxErrorFetchingData, rxSetRequest, rxSetSelectedTicket, rxStartFetching, rxSuccessFetchingData } =
  checkTicketsSlice.actions;
export const checkTicketsSelector = (state: { checkTickets: CheckTicketsState }) => state.checkTickets;
export default checkTicketsSlice.reducer;
